module.exports = __webpack_public_path__ + "static/media/cellfinate_banner_social.9ac751bc.jpg";